module.exports = __webpack_public_path__ + "static/media/about-2.0ab49308.jpg";